import {
  CompletionRequirement,
  Timing,
} from '@wix/ambassador-bookings-services-v2-service/types';
import {
  SlotServices,
  IntakeForms,
  SlotService,
  IntakeFormStatus,
} from './types';
import { mapToArray } from '../index';

export function extractIntakeFormsFromServices({
  slotServices,
}: {
  slotServices: SlotServices;
}): IntakeForms {
  const forms: IntakeForms = {};

  mapToArray<SlotService>(slotServices).forEach(
    async (slotService: SlotService) => {
      const intakeFormPolicy = slotService.service?.intakeFormPolicy;

      if (!intakeFormPolicy?.formId) {
        return;
      }

      const { formId, enabled, completionRequirement, timing } =
        intakeFormPolicy;
      const timingIsBeforeBooking = timing === Timing.BEFORE_BOOKING;
      const isValidCompletionRequirement =
        completionRequirement ===
          CompletionRequirement.REQUIRED_BEFORE_BOOKING ||
        completionRequirement === CompletionRequirement.OPTIONAL;

      if (
        enabled &&
        timingIsBeforeBooking &&
        isValidCompletionRequirement &&
        !forms[formId]
      ) {
        const status =
          completionRequirement ===
          CompletionRequirement.REQUIRED_BEFORE_BOOKING
            ? IntakeFormStatus.REQUIRED
            : IntakeFormStatus.OPTIONAL;

        forms[formId] = {
          formId,
          completionRequirement,
          status,
        };
      }
    },
  );

  return forms;
}
